import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { StateService, UIRouterModule } from '@uirouter/angular';

import { DropdownModule } from '@app/primeng-overrides/dropdown';
import { ButtonModule } from 'primeng/button';

import { Abonne } from '@app/abonne/abonne.model';
import { GlobalModule } from '@global/global.module';
import { AbonneService } from '@app/abonne/abonne.service';
import { Utilisateur } from '@app/utilisateur/utilisateur.model';
import { AbonneLogoDisplayModule } from '@app/abonne/abonne-logo-display/abonne-logo-display';

@Component({
	selector: 'selection-abonne-courant',
	template: `
		<div class="flex flex-column align-items-center w-full">
			<form>
				<div class="field w-20rem">
					<label class="text-2xl mt-3 mb-3"> {{ 'abonnes.current_abonne_selector' | translate }} </label>

					<p-dropdown
						*ngIf="choices"
						name="abo_id"
						required
						[options]="choices"
						[(ngModel)]="abo_id"
						(ngModelChange)="onSelectionChange()"
						[filter]="choices.length > 5"
						filterBy="abo_nom_abonne"
						placeholder="{{'abonnes.select'|translate}}"
						optionValue="abo_id"
						optionLabel="abo_nom_abonne"
						appendTo="body"
						styleClass="w-10 h-3rem"
						inputStyleClass="flex flex-row align-items-center"
					>
						<ng-template *ngIf="me.uti_administrateur" pTemplate="header">
							<p-checkbox
								name="abo_actif"
								class="m-2"
								[(ngModel)]="abo_actif"
								(ngModelChange)="onAboActifChange()"
								[binary]="true"
								[label]="'abonnes.inactive_abonnes' | translate"
								[trueValue]="false"
								[falseValue]="true"
							></p-checkbox>
						</ng-template>

						<ng-template let-selectedItem pTemplate="selectedItem">
							<div class="flex flex-row align-items-center">
								<div class="mr-2">
									<logo-display [abonne]="selectedItem" width="3rem"></logo-display>
								</div>
								{{selectedItem.abo_nom_abonne}}
							</div>
						</ng-template>

						<ng-template let-item pTemplate="item">
							<div class="flex flex-row align-items-center">
								<div class="mr-2">
									<logo-display [abonne]="item" width="3rem"></logo-display>
								</div>
								{{item.abo_nom_abonne}}
							</div>
						</ng-template>

					</p-dropdown>
				</div>

				<button
					type="button"
					pButton
					icon="pi pi-arrow-left"
					[label]="'common.back_button_label' | translate"
					(click)="goBack()"
				></button>
			</form>
		<div>
	`
})
export class SelectionAbonneCourantComponent implements OnInit {

	@Input() me: Utilisateur;
	@Input() choices: Abonne[];

	abonnes: Abonne[];
	abo_id: number;
	abo_actif: boolean = true;

	constructor(
		private stateService: StateService,
		private abonneService: AbonneService,
	) {
	}

	ngOnInit(): void {
		if (this.me.uti_administrateur) {
			// L'administrateur a accès à tous les abonnés.
			this.abonneService.getCacheAbonnes()
			.subscribe(({ abonnes }) => {
				this.abonnes = abonnes;
				this.choices = this.abonnes.filter((abo: Abonne) => abo.abo_actif === this.abo_actif);
			});
		}
		else {
			this.choices = this.me.abonnes;
			this.abonnes = this.choices;
		}
	}

	onAboActifChange() {
		this.choices = this.abonnes.filter((abo: Abonne) => abo.abo_actif === this.abo_actif);
	}

	onSelectionChange(){
		if (this.abo_id == undefined) {
			return;
		}
		this.abonneService.currentAbonneValue = null;
 		this.stateService.go('abonne-courant', {curr_abo_id: this.abo_id});
	}

	goBack() {
		let abo_id = this.abonneService.currentAbonneValue?.abo_id;
		if (abo_id != undefined) {
			this.stateService.go('abonne-courant', {curr_abo_id: abo_id});
		}
		else {
			this.stateService.go('admin');
		}
	}

}

@NgModule({
	imports: [
		CommonModule,
		UIRouterModule,
		GlobalModule,
		DropdownModule,
		FormsModule,
		ButtonModule,
		AbonneLogoDisplayModule,
		AbonneLogoDisplayModule
	],
	exports: [SelectionAbonneCourantComponent],
	declarations: [SelectionAbonneCourantComponent]
})
export class SelectionAbonneCourantModule { }
